import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { getComponentPropType } from '../utils/propTypes/componentProp';
import styled from 'styled-components';
const LAST_WHITESPACE_REGEX = /\s(?!.+\s)/m;

const truncateStr = (str, maxLength) => {
  if (str.length <= maxLength) return null;
  const minLength = maxLength - 20; // Don't cut the string too short

  const lastWordBoundaryMatch = str.slice(0, maxLength).match(LAST_WHITESPACE_REGEX);

  if (lastWordBoundaryMatch && lastWordBoundaryMatch.index && lastWordBoundaryMatch.index > minLength) {
    return `${str.slice(0, lastWordBoundaryMatch.index)}…`;
  }

  return `${str.slice(0, maxLength)}…`;
};

const UITruncateMultilineParagraph = styled.p.withConfig({
  displayName: "UITruncateMultiline__UITruncateMultilineParagraph",
  componentId: "nc3tva-0"
})([""]);
UITruncateMultilineParagraph.propTypes = {
  children: PropTypes.node.isRequired
};

class UITruncateMultiline extends PureComponent {
  render() {
    const _this$props = this.props,
          {
      text,
      maxChars,
      Paragraph = UITruncateMultilineParagraph,
      tagName
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["text", "maxChars", "Paragraph", "tagName"]);

    const Element = tagName || 'span';
    let remainingLength = maxChars != null ? maxChars : Infinity;
    const rawParagraphs = Array.isArray(text) ? text : [text];
    const paragraphNodes = [];

    for (let i = 0; i < rawParagraphs.length; i++) {
      const originalParagraph = rawParagraphs[i];
      const truncatedParagraph = truncateStr(originalParagraph, remainingLength);

      if (truncatedParagraph != null) {
        paragraphNodes.push( /*#__PURE__*/_jsx(Paragraph, {
          children: truncatedParagraph
        }, i));
        break;
      }

      paragraphNodes.push( /*#__PURE__*/_jsx(Paragraph, {
        children: originalParagraph
      }, i));
      remainingLength -= originalParagraph.length;
    }

    return /*#__PURE__*/_jsx(Element, Object.assign({}, rest, {
      children: paragraphNodes
    }));
  }

}

UITruncateMultiline.propTypes = {
  maxChars: PropTypes.number,
  Paragraph: getComponentPropType(UITruncateMultilineParagraph).isRequired,
  // @ts-expect-error There isn't an easy way to grab all possible options in JS, so a generic "string" prop type here is good enough
  tagName: PropTypes.string.isRequired,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired
};
UITruncateMultiline.defaultProps = {
  Paragraph: UITruncateMultilineParagraph,
  tagName: 'span'
};
UITruncateMultiline.displayName = 'UITruncateMultiline';
export default UITruncateMultiline;